import React from 'react'
import EditorOutputCreator from '../utils/editor-output-creator'
import { getPreviewUploads } from '../utils/product-preview'
import CartApi from '../utils/cart-api'
import AdobeAnalytics from '../utils/adobe-analytics'
import OrderStore from '../stores/order-store'
import ImageStore from '../stores/image-store'
import UploadStore from '../stores/upload-store'
import Loader from './utils/ope-loader'
import URLMapper from "../utils/url-mapper"
import Timer from "../utils/timer"
import createReactClass from 'create-react-class'
import Config from "../config";

/**
 * This component gets loaded when the customer is done with his order and has
 * pressed the "Add to cart" button
 */
// Max wait for the best-effort preview uploads before ordering without them.
var PREVIEW_TIMEOUT_MS = 10000;

// Copy each line's PreviewImageID onto the payload images. Map is keyed by order-item id; images are
// built from getItems() in the same order, so zip by index.
function applyPreviewImageIds(editorOutput, previewMap) {
    if (!previewMap || !editorOutput || !editorOutput.product || !editorOutput.product.images) {
        return;
    }
    var items = OrderStore.getItems() || [];
    editorOutput.product.images.forEach(function (image, index) {
        var item = items[index];
        var id = item && previewMap[item.getId()];
        if (id) {
            image.PreviewImageID = id;
        }
    });
}

var Finished = createReactClass({
    mounted: false,
    waitingForLinkingUploadsToUser: false,

    getInitialState: function () {
        return {statusMessage: _('Adding cart items. Two more steps...')};
    },

    componentDidMount: function () {
        var instance = this;
        instance.mounted = true;
        instance.try = 0;

        // Make sure all uploads have finished
        var uploadData = UploadStore.getData();

        if (Object.keys(OrderStore.getItems()).length === 0) {
            instance.setState({statusMessage: _('Empty session.')});
            window.location.hash = "";
        } else if (uploadData.totalImagesToUpload > 0 && uploadData.totalImagesToUpload !== uploadData.serverData) {
            // totalImagesUploaded does not represent the final state of file's upload process.
            instance.setState({statusMessage: _('Upload is not finished.')});
            window.location.hash = "/upsale";
        } else {
            //Log analytics data
            AdobeAnalytics.setFinished();
            this.addOrderToCart();
        }

    },
    addOrderToCart: function () {
        const data = UploadStore.getData()
        logToCentralServer("Finish page, upload stats", {
            "totalImagesUploaded": data.totalImagesUploaded,
            "totalImagesToUpload": data.totalImagesToUpload,
            "totalImagesFailed": data.totalImagesFailed,
            "totalImagesRegistered": data.totalImagesRegistered,
            "serverData": data.serverData,
          }, Config.LogLevel.INFO)

        var instance = this;

        //Create the JSON data that summarizes all of the images and options selected by the customer
        var editorOutputCreator = new EditorOutputCreator();
        var editorOutput = editorOutputCreator.create();

        instance.attachPreviewImageIds(editorOutput).then(function () {
            var jsonData = JSON.stringify(editorOutput, null);

            //Add the order to the cart
            return CartApi.addToCart(jsonData);
        }).then(this.doneAddingCartItems).then(this.waitForCartRedirectUrlAndLinkToAnonymous).then(function (cartRedirectLinks) {

            if (instance.mounted) {
                instance.setState({statusMessage: _('Redirecting to cart. Just a moment...')});
            }

            //Since we are redirecting, remove event listener that warns about leaving the page
            window.removeEventListener('beforeunload', global.leavePageWarning);

            AdobeAnalytics.setRedirectingToCart()

            //Redirect to cart
            window.top.location.href = URLMapper.mapToSecure(cartRedirectLinks.href);
        })['catch'](function (err) {
            instance.try++;
            if (instance.try <= 10) {
                // Some error happened. Let's give a user friendly message.
                instance.setState({statusMessage: _("Loading, please wait")});

                // Retry after a few seconds.
                Timer.set("addOrder", function() {
                    instance.addOrderToCart();
                }.bind(instance), instance.try * 10 * 1000 );
            }
            else {
                // Give up.
                displayError(err.message, err, Config.LogLevel.ERROR, "ADD_TO_CART_ERROR");
                instance.setState({statusMessage: err.message});
            }
        });
    },

    // Best-effort: set a per-image PreviewImageID (one per cart line); cached across the retry loop,
    // never blocks ordering.
    attachPreviewImageIds: function (editorOutput) {
        var instance = this;

        if (instance.previewResolved) {
            applyPreviewImageIds(editorOutput, instance.previewMap);
            return Promise.resolve();
        }

        // Reuse the pre-warmed uploads, capped by a timeout so a stuck render can't block checkout.
        var timeoutId;
        var timeout = new Promise(function (resolve) {
            timeoutId = setTimeout(function () { resolve(null); }, PREVIEW_TIMEOUT_MS);
        });

        return Promise.race([getPreviewUploads(), timeout]).then(function (previewMap) {
            // previewMap is null only when the timeout won; the uploads promise itself never rejects and
            // resolves to a (possibly empty) map. Don't latch previewResolved on the timeout path, so a
            // retry can still pick up the background upload once it finishes.
            if (previewMap) {
                instance.previewResolved = true;
                instance.previewMap = previewMap;
            }
            applyPreviewImageIds(editorOutput, previewMap);
        }).finally(function () {
            clearTimeout(timeoutId);
        });
    },

    doneAddingCartItems: function (cartId) {
        var instance = this;
        return new Promise(function (resolve, reject) {
            if (instance.mounted) {
                instance.setState({statusMessage: _('We’re processing your order. One more step…')});
            }
            resolve(cartId);
        });
    },

    waitForCartRedirectUrlAndLinkToAnonymous: function (cartId) {
        var self = this;
        return new Promise(function (resolve, reject) {

            function checkStatus() {
                CartApi.getStatus(cartId).then(function (status) {
                    if (status.status === "Finished" && self.waitingForLinkingUploadsToUser == false) {
                        resolve(status.links[0]);
                    } else if (status.status === "Failed") {
                        displayError(_("Something went wrong when adding items to cart. See details below."), {
                            cartId: cartId,
                            error: 'Unknown'
                        });
                        reject(_("Something went wrong when adding items to cart. See details below."));
                    } else {
                        Timer.set("redirectURL", function() {
                            checkStatus()
                        }.bind(CartApi, cartId, resolve, self), 1000);
                    }
                });
            }
            checkStatus();
        });
    },

    render: function () {
        return (
            <section>
                <div className="ope-finished-message">
                    {this.state.statusMessage}
                </div>
                <div className="ope-finished-loader">
                    <Loader/>
                </div>
            </section>
        );
    },
    componentWillUnmount: function() {
        this.mounted = false;
    }
});

export default Finished;
